import { Alert, Button, Badge, FileInput, Textarea } from "flowbite-react";

import init, { fill_pdf_form } from 'pdf_form_filler';

import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";
import "./App.css";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { useEffect, useState } from "react";

dayjs.extend(customParseFormat);
const CACHE_PDF_KEY = "pdf";
const CACHE_EXCEL_KEY = "excel";
const PDF_FORM_DATA_KEY = "pdf_form_data";

const DEFAULT_FORM_DATA = {
  "Full Name": "",
  "Contact No": "",
  "Email": "",
  "Job Position": "Full Stack Engineer",
  "Company": "",
  "Approving Manager": ""
};

let pdfBytes = null;

const holidays = {
  2026: [
    ["New Year's Day", "01/01"],
    ["Chinese New Year", "17/02"],
    ["Chinese New Year", "18/02"],
    ["Hari Raya Puasa", "21/03"],
    ["Good Friday", "3/04"],
    ["Labour Day", "01/05"],
    ["Vesak Day", "31/05"],
    ["Hari Raya Haji", "27/05"],
    ["National Day", "09/08"],
    ["Deepavali", "08/10"],
    ["Christmas Day", "25/12"],
  ],
};

const LEAVE_TYPES = [
  {
    id: "Medical",
    label: "Medical Leave",
    code: "MC",
    excelColumn: "E",
    color: "warning",
    pickerStyle: {
      color: "rgb(114, 59, 19)",
      backgroundColor: "rgb(253, 246, 178)",
      fontWeight: "600",
    },
  },
  {
    id: "Leave",
    label: "Annual Leave",
    code: "AL",
    excelColumn: "G",
    color: "success",
    pickerStyle: {
      color: "rgb(3, 84, 63)",
      backgroundColor: "rgb(222, 247, 236)",
      fontWeight: "600",
    },
  },
  {
    id: "ChildcareLeave",
    label: "Childcare Leave",
    code: "CCL",
    excelColumn: "F",
    color: "indigo",
    pickerStyle: {
      color: "rgb(30, 66, 159)",
      backgroundColor: "rgb(224, 231, 255)",
      fontWeight: "600",
    }
  },
  {
    id: "NationalService",
    label: "National Service Leave",
    code: "NSL",
    excelColumn: "H",
    color: "failure",
    pickerStyle: {
      color: "rgb(155, 28, 28)",
      backgroundColor: "rgb(253, 232, 232)",
      fontWeight: "600",
    },
  },
  {
    id: "FamilyCare",
    label: "Family Care Leave",
    code: "FCL",
    excelColumn: "H",
    color: "pink",
    pickerStyle: {
      color: "rgb(153, 21, 75)",
      backgroundColor: "rgb(252, 231, 243)",
      fontWeight: "600",
    },
  },
];

const thisYear = new Date().getFullYear();

function PublicHoliday() {
  return (
    <div>
      <Badge size={2} color="purple">
        Public Holiday
      </Badge>
      <ul style={{ padding: 9 }}>
        {holidays[thisYear].map((e) => (
          <li key={e[0]}>
            - {e[1]} {e[0]}{" "}
          </li>
        ))}
      </ul>
    </div>
  );
}

// Takes in the month we want to generate the timesheet for
function getTimesheetMapping(month, specialDates) {
  console.log("Generating timesheet", month);
  let results = {};

  let totalDaysInMonth = dayjs(month).daysInMonth();
  let monthInstance = dayjs(month).startOf("month");

  for (let i = 1; i <= 31; i++) {
    if (i > totalDaysInMonth) {
      results[`Start${i}`] = "";
      results[`End${i}`] = "";
      results[`Break${i}`] = "";
      continue;
    }

    // Check of Holiday, AL and MC first
    let current = monthInstance.date(i);
    let dayName = current.format("ddd");
    let dd_mm = current.format("DD/MM");

    //   console.log(dd_mm);
    if (isHoliday(dd_mm)) {
      console.log(dd_mm + " is a holiday");
      results[`Start${i}`] = "";
      results[`End${i}`] = "";
      results[`Break${i}`] = "";
      results[`Remarks${i}`] = "PH";
      continue;
    }

    // Dynamic Leave Types
    let foundType = null;
    for (const type of LEAVE_TYPES) {
      if (specialDates[type.id] && specialDates[type.id].includes(dd_mm)) {
        foundType = type;
        break;
      }
    }

    if (foundType) {
      console.log(dd_mm + " is " + foundType.id);
      results[`Start${i}`] = "";
      results[`End${i}`] = "";
      results[`Break${i}`] = "";
      results[`Remarks${i}`] = foundType.code;
      continue;
    }

    if (["Sat", "Sun"].includes(dayName)) {
      results[`Start${i}`] = "";
      results[`End${i}`] = "";
      results[`Break${i}`] = "";
      continue;
    }

    if (dayName === "Fri") {
      results[`Start${i}`] = "08:30";
      results[`End${i}`] = "17:30";
      results[`Break${i}`] = "60mins";
      continue;
    } else {
      results[`Start${i}`] = "08:30";
      results[`End${i}`] = "18:00";
      results[`Break${i}`] = "60mins";
      continue;
    }
  }

  console.log(results);
  return results;
}

function getExcelTimesheetMapping(month, specialDates) {
  console.log("Get Excel Timesheet Cell Data", month);
  // [B12, C12|D12|E12|G12]
  let replaceList = [];

  let totalDaysInMonth = dayjs(month).daysInMonth();
  let monthInstance = dayjs(month).startOf("month");
  let startIndex = 12;

  for (let i = 1; i <= 31; i++) {
    if (i > totalDaysInMonth) {
      continue;
    }

    // Check of Holiday, AL and MC first
    let current = monthInstance.date(i);
    let dayName = current.format("ddd");
    let dd_mm = current.format("DD/MM");

    // Prepare our dates first
    let rowIndex = startIndex + i - 1;
    replaceList.push("B" + rowIndex);
    replaceList.push(current.format("D/MM/YYYY"));

    if (isHoliday(dd_mm)) {
      console.log(dd_mm + " is a holiday");
      replaceList.push("D" + rowIndex);
      replaceList.push("1");

      continue;
    }

    // Dynamic Leave Types
    let foundType = null;
    for (const type of LEAVE_TYPES) {
      if (specialDates[type.id] && specialDates[type.id].includes(dd_mm)) {
        foundType = type;
        break;
      }
    }

    if (foundType) {
      console.log(dd_mm + " is " + foundType.id);
      replaceList.push(foundType.excelColumn + rowIndex);
      replaceList.push("1");
      continue;
    }

    if (["Sat", "Sun"].includes(dayName)) {
      continue;
    } else {
      replaceList.push("C" + rowIndex);
      replaceList.push("1");
    }
  }

  console.log(replaceList);
  return replaceList.join(",");
}

// date should be in dd/mm
function isHoliday(date) {
  return holidays[thisYear].flat().includes(date);
}

function getMonthWeekendDates(month) {
  let checkMonth = dayjs(month).startOf("month");
  let totalDaysInMonth = checkMonth.daysInMonth();

  let toDisable = [];
  for (let i = 0; i < totalDaysInMonth; i++) {
    let day = checkMonth.add(i, "days");
    if (["Sat", "Sun"].includes(day.format("ddd"))) {
      toDisable.push(day.toDate());
    }
  }

  return toDisable;
}

// byteArray is a Uint8Array
function arrayBufferToHex(byteArray) {
  const hexParts = [];

  byteArray.forEach((byte) => {
    const hex = byte.toString(16).padStart(2, "0"); // Convert each byte to hex and pad with '0' if needed
    hexParts.push(hex);
  });

  return hexParts.join("");
}

function hexToByteArray(hexString) {
  if (hexString.length % 2 !== 0) {
    throw new Error("Hex string must have an even number of characters");
  }

  const buffer = new ArrayBuffer(hexString.length / 2);
  const byteArray = new Uint8Array(buffer);

  for (let i = 0; i < hexString.length; i += 2) {
    byteArray[i / 2] = parseInt(hexString.substr(i, 2), 16); // Convert every 2 hex characters to a byte
  }

  return byteArray;
}

// Cache last loaded template
function cacheTemplate(arrayBuffer, key) {
  localStorage.setItem(key, arrayBufferToHex(arrayBuffer));
}

// Generate from last loaded template
function getCachedTemplate(key) {
  let cachedHex = localStorage.getItem(key);

  if (!cachedHex) {
    alert(
      "there's nothing cached, load a template and it'll be cached in your local storage"
    );
    return null;
  }

  return hexToByteArray(cachedHex);
}

function App() {
  const [selectedDates, setSelectedDates] = useState([]);
  const [selectedOption, setSelectionOption] = useState(LEAVE_TYPES[0].id);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [disabledDates, setDisabledDates] = useState([]);
  const [isPdfLoaded, setIsPdfLoaded] = useState(false);
  const [isExcelLoaded, setIsExcelLoaded] = useState(false);

  // Initialize from LEAVE_TYPES
  const [specialDates, setSpecialDates] = useState(
    LEAVE_TYPES.reduce((acc, type) => ({ ...acc, [type.id]: [] }), {})
  );

  const [pdfFormData, setPdfFormData] = useState(
    JSON.stringify(DEFAULT_FORM_DATA, null, 2)
  );

  useEffect(() => {
    const cachedData = localStorage.getItem(PDF_FORM_DATA_KEY);
    if (cachedData) {
      setPdfFormData(cachedData);
    }
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      localStorage.setItem(PDF_FORM_DATA_KEY, pdfFormData);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [pdfFormData]);

  useEffect(() => {
    setDisabledDates(getMonthWeekendDates(selectedMonth));

    init();
  }, [selectedMonth]);

  function displaySpecialDays(key) {
    return (
      <ul style={{ padding: 9 }}>
        {specialDates[key].map((e) => (
          <li key={key + e}>- {e}</li>
        ))}
      </ul>
    );
  }

  function generatePDFSheet(bytes) {
    let config = getTimesheetMapping(
      selectedMonth,
      specialDates
    );

    try {
      const formData = JSON.parse(pdfFormData);
      config = { ...config, ...formData, "MonthYear_af_date": format(selectedMonth, "MM/yyyy") };
    } catch (e) {
      console.error("Invalid JSON in form data", e);
      alert("Invalid JSON in form data");
      return;
    }

    /* eslint-disable  */
    const filledPdf = fill_pdf_form(bytes, JSON.stringify(config));
    const blob = new Blob([filledPdf], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Timesheet ${format(selectedMonth, "MMM")}.pdf`
    a.click();
  }

  function Info() {
    return (
      <div>
        <Badge
          size={2}
          color="dark"
          style={{ fontWeight: "bold" }}
          onClick={() => setSelectionOption("Leave")}
        >
          Information
        </Badge>
        <p style={{ padding: 9 }}>
          Everything is processed locally using WebAssembly and Javascript. View
          the{" "}
          <a
            href="https://www.youtube.com/watch?v=9eriY9HXRCA"
            className="font-medium text-blue-600 underline dark:text-blue-500 hover:no-underline"
            target="_blank"
            rel="noreferrer"
          >
            tutorial video
          </a>
          . Or download the{" "}
          <a
            href="https://public.r2.hongchai.cc/Timesheet.pdf"
            className="font-medium text-blue-600 underline dark:text-blue-500 hover:no-underline"
          >
            PDF template
          </a>{" "}
          and{" "}
          <a
            href="https://public.r2.hongchai.cc/template_demo.xlsx"
            className="font-medium text-blue-600 underline dark:text-blue-500 hover:no-underline"
          >
            excel template.
          </a>{" "}
          Also{" "}
          <a
            href={`mailto:?subject=Timesheet for ${format(
              selectedMonth,
              "MMMM yyyy"
            )}&body=${getEmailTemplate()}`}
            className="font-medium text-blue-600 underline dark:text-blue-500 hover:no-underline"
          >
            mail template
          </a>{" "}
          for a fast compose.
        </p>
      </div>
    );
  }

  function getEmailTemplate() {
    const j = JSON.parse(pdfFormData);
    const managerName = j["Approving Manager"].split(" ")[0];
    const me = j["Full Name"];

    let leaveDetails = "";
    LEAVE_TYPES.forEach((type) => {
      const dates = specialDates[type.id];
      if (dates && dates.length > 0) {
        leaveDetails += `%0A%0A${type.label}:%0A${dates
          .map((d) => `- ${d}`)
          .join("%0A")}`;
      }
    });

    return `Hi ${managerName},%0AI have attached my timesheet for the month of ${format(
      selectedMonth,
      "MMMM yyyy"
    )}.${leaveDetails}%0A%0APlease let me know if there are any mistakes in it.%0AThank you.%0A%0ABest regards,%0A${me}`;
  }

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ flex: 3 }}>
        {Info()}
        {PublicHoliday()}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {LEAVE_TYPES.map((type) => (
            <div key={type.id}>
              <Badge
                size={2}
                color={type.color}
                style={
                  selectedOption === type.id
                    ? { fontWeight: "bold", fontSize: "1.4em" }
                    : {}
                }
                onClick={() => setSelectionOption(type.id)}
              >
                {type.label}{" "}
                {specialDates[type.id] && specialDates[type.id].length > 0
                  ? `(${specialDates[type.id].length})`
                  : ""}
              </Badge>
              {displaySpecialDays(type.id)}
            </div>
          ))}
        </div>
        <Badge size={2} color="dark">
          PDF Template File
        </Badge>

        <div
          id="fileUpload"
          className="max-w-md"
          style={{ padding: 9, marginBottom: "6px" }}
        >
          <FileInput
            id="template"
            style={{ fontSize: "0.8em" }}
            accept=".pdf"
            onChange={function (e) {
              const reader = new FileReader();
              reader.onload = function () {
                const arrayBuffer = this.result;
                const array = new Uint8Array(arrayBuffer);

                /* eslint-disable  */
                pdfBytes = array;
                /* eslint-enable */
                setIsPdfLoaded(true);
                cacheTemplate(array, CACHE_PDF_KEY);
              };

              if (e.target.files.length > 0)
                reader.readAsArrayBuffer(e.target.files[0]);
            }}
          />

          <Textarea
            value={pdfFormData}
            onChange={(e) => setPdfFormData(e.target.value)}
            rows={10}
            style={{ fontSize: "0.8em", fontFamily: "monospace" }}
          />

          <Button
            id="generate"
            style={{ marginTop: 9, width: "100%" }}
            disabled={!isPdfLoaded}
            onClick={() => {
              generatePDFSheet(pdfBytes);
            }}
          >
            Generate Timesheet
          </Button>

          {/* <Button
            id="pdfform"
            style={{ marginTop: 9, width: "100%" }}
            disabled={!isPdfLoaded}
            onClick={() => {
              const formFields = get_form_fields(pdfBytes);
              console.log(formFields);
            }}
          >
            Print PDF Form Fields in Console
          </Button> */}
        </div>
        <Badge size={2} color="dark">
          Excel Template File
        </Badge>

        <div
          id="fileUpload"
          className="max-w-md"
          style={{ padding: 9, marginBottom: "6px" }}
        >
          <FileInput
            id="template"
            style={{ fontSize: "0.8em" }}
            onChange={function (e) {
              const reader = new FileReader();
              reader.onload = function () {
                const arrayBuffer = this.result;
                const array = new Uint8Array(arrayBuffer);

                const loaded = loadExcelTemplate(array); // eslint-disable-line
                setIsExcelLoaded(loaded);

                if (!loaded) {
                  alert("Failed reading excel template file");
                }

                cacheTemplate(array, CACHE_EXCEL_KEY);
              };

              if (e.target.files.length > 0)
                reader.readAsArrayBuffer(e.target.files[0]);
            }}
          />

          <Button
            id="generate"
            style={{ marginTop: 9, width: "100%" }}
            disabled={!isExcelLoaded}
            onClick={() => {
              let config = getExcelTimesheetMapping(
                selectedMonth,
                specialDates
              );

              /* eslint-disable  */
              generateExcelTemplate(
                `Timesheet ${format(selectedMonth, "MMM")}.xlsx`,
                format(selectedMonth, "MMM/yyyy"),
                config
              );
              /* eslint-enable */
            }}
          >
            Generate Timesheet
          </Button>
        </div>

        <Badge size={2} color="dark">
          Generate from cache (uses your last PDF and Excel file)
        </Badge>

        <Button
          id="generate"
          style={{ marginTop: 9, width: "100%" }}
          onClick={() => {
            const pdfUIntArray = getCachedTemplate(CACHE_PDF_KEY);

            if (!pdfUIntArray) return;
            generatePDFSheet(pdfUIntArray);
          }}
        >
          Generate PDF Timesheet
        </Button>

        <Button
          id="generate"
          style={{ marginTop: 9, width: "100%" }}
          onClick={() => {
            let config = getExcelTimesheetMapping(
              selectedMonth,
              specialDates
            );

            const excelDocUIntArray = getCachedTemplate(CACHE_EXCEL_KEY);

            if (!excelDocUIntArray) return;
            loadExcelTemplate(excelDocUIntArray); // eslint-disable-line

            /* eslint-disable  */
            generateExcelTemplate(
              `Timesheet ${format(selectedMonth, "MMM")}.xlsx`,
              format(selectedMonth, "MMM/yyyy"),
              config
            );
            /* eslint-enable */
          }}
        >
          Generate Excel Timesheet
        </Button>
      </div>
      <div style={{ flex: 8 }}>
        {
          <DayPicker
            mode="multiple"
            fromYear={2026}
            modifiers={LEAVE_TYPES.reduce(
              (acc, type) => ({
                ...acc,
                [type.id]: specialDates[type.id].map((e) =>
                  dayjs(e + "/" + thisYear, "DD/MM/YYYY").toDate()
                ),
              }),
              {
                publicHolidays: holidays[thisYear].map((e) =>
                  dayjs(e[1] + "/" + thisYear, "DD/MM/YYYY").toDate()
                ),
              }
            )}
            modifiersStyles={LEAVE_TYPES.reduce(
              (acc, type) => ({
                ...acc,
                [type.id]: type.pickerStyle,
              }),
              {
                publicHolidays: {
                  color: "rgb(85 33 181)",
                  backgroundColor: "rgb(237, 235, 254)",
                  fontWeight: "600",
                },
              }
            )}
            selected={selectedDates}
            month={selectedMonth}
            disabled={disabledDates}
            onMonthChange={setSelectedMonth}
            onSelect={(date) => {
              // Check if is new item or remove item
              if (date.length > selectedDates.length) {
                // Check if the clicked item is a Public Holiday
                let selectedDate = format(date[date.length - 1], "dd/MM");

                if (holidays[thisYear].find((e) => e[1] === selectedDate)) {
                  console.log(
                    "clicked date is a public holiday, nothing to do"
                  );
                  return;
                }

                let copy = {
                  ...specialDates,
                };

                copy[selectedOption].push(selectedDate);
                copy[selectedOption].sort();

                setSpecialDates(copy);
              } else {
                // Removed something
                console.log("Removed item");
                let formattedDates = date.map((e) => format(e, "dd/MM"));

                let keys = Object.keys(specialDates);

                let allSpecialDates = [];
                for (let i = 0; i < keys.length; i++) {
                  allSpecialDates = allSpecialDates.concat(
                    specialDates[keys[i]]
                  );
                }

                let difference = "";

                for (let i = 0; i < allSpecialDates.length; i++) {
                  let checkValue = allSpecialDates[i];
                  if (!formattedDates.includes(checkValue)) {
                    difference = checkValue;
                    console.log(checkValue + " should be removed");
                  }
                }

                for (let i = 0; i < keys.length; i++) {
                  const key = keys[i];
                  let indexToRemove = specialDates[key].indexOf(difference);

                  if (indexToRemove !== -1) {
                    let copy = { ...specialDates };
                    copy[key].splice(indexToRemove, 1);
                    copy[key].sort();
                    setSpecialDates(copy);
                    break;
                  }
                }
              }

              setSelectedDates(date);
            }}
            footer={
              <Alert color="info" withBorderAccent>
                Click on the <b>Leave Type</b> on the left and select a day.{" "}
              </Alert>
            }
          />
        }
      </div>
    </div >
  );
}

export default App;
